import { render, staticRenderFns } from "./DiscoveryAICategoryView.vue?vue&type=template&id=8e263c84&scoped=true"
import script from "./DiscoveryAICategoryView.vue?vue&type=script&lang=js"
export * from "./DiscoveryAICategoryView.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryAICategoryView.vue?vue&type=style&index=0&id=8e263c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e263c84",
  null
  
)

export default component.exports